import { MenuTrigger } from 'react-aria-components';
import { ClarionButton } from '../clarion/ClarionButton';
import { ClarionMenu, ClarionMenuItem } from '../clarion/ClarionMenu';
import { FileLabel as FileLabelType } from './assignment';
import FileLabelComponent from './FileLabel';

interface LabelMultiSelectProps {
  availableLabels: FileLabelType[];
  selectedLabelIds: string[];
  onSelectionChange: (labelIds: string[]) => void;
}

export default function LabelMultiSelect({
  availableLabels,
  selectedLabelIds,
  onSelectionChange,
}: LabelMultiSelectProps) {
  const selectedLabels = availableLabels.filter((l) => selectedLabelIds.includes(l.id));
  const displayText =
    selectedLabels.length > 0
      ? `${selectedLabels.length} label${selectedLabels.length === 1 ? '' : 's'} selected`
      : 'Select labels...';

  return (
    <MenuTrigger>
      <ClarionButton variant="outlined" endIcon="chevron-down" fill textAlign="left">
        <span className="flex grow items-center gap-2 justify-between">
          <span className="flex flex-wrap gap-1 grow">
            {selectedLabels.map((label) => (
              <FileLabelComponent key={label.id} label={label} minimal />
            ))}
            {selectedLabels.length === 0 && displayText}
          </span>
        </span>
      </ClarionButton>
      <ClarionMenu
        selectionMode="multiple"
        selectedKeys={selectedLabelIds}
        onSelectionChange={(keys) => {
          if (typeof keys !== 'string') {
            onSelectionChange(Array.from(keys) as string[]);
          }
        }}
      >
        {availableLabels.map((label) => (
          <ClarionMenuItem key={label.id} id={label.id}>
            <FileLabelComponent label={label} minimal />
          </ClarionMenuItem>
        ))}
      </ClarionMenu>
    </MenuTrigger>
  );
}
